// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I9qitBUsK1qxrtishKcA {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* ── Chart data row ─────────────────────────────────────── */

.BrIkaPNCgh3paJc1l9O9 {
  display: flex;
  align-items: flex-start;
  padding: 12px 12px 0;
}

.KEdDE7x4Iouw1TOGtFZR {
  flex-shrink: 0;
  height: 280px;
}

.DmjM_grAlgF6YqICGopA {
  position: relative;
  flex: 1;
  min-width: 0;
}

.DmjM_grAlgF6YqICGopA::before,
.DmjM_grAlgF6YqICGopA::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px;
  pointer-events: none;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.15s;
}

.DmjM_grAlgF6YqICGopA::before {
  left: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.07), transparent);
}

.DmjM_grAlgF6YqICGopA::after {
  right: 0;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.07), transparent);
}

.fZo9SSWK4XKkwgPmrTf_::before { opacity: 1; }
.PaW7Iqc8IthirEjD3X80::after { opacity: 1; }

.nP0HEm9ZhhmAhB3beskA { cursor: grab; }
.dskrNN8TL9fTjKeHYRnY { cursor: grabbing; }

.d1EM8WLfuxvayimV_HZn {
  height: 280px;
  overflow-x: auto;
  overflow-y: hidden;
  user-select: none;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.45) transparent;
}

.d1EM8WLfuxvayimV_HZn::-webkit-scrollbar {
  height: 4px;
}

.d1EM8WLfuxvayimV_HZn::-webkit-scrollbar-track {
  background: transparent;
}

.d1EM8WLfuxvayimV_HZn::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.45);
  border-radius: 2px;
}

.d1EM8WLfuxvayimV_HZn::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.62);
}

.KMss1DjKcj64o2eVAqiV {
  position: relative;
  height: 100%;
  width: 100%;
}

/* ── X-axis strip (separate row, scroll synced to main) ── */

.J09ihN6fRc3UTWzOvzTk {
  display: flex;
  padding: 0 12px;
}

.jZ8gDvCtWyBNeUhyk4B_ {
  flex-shrink: 0;
  width: 80px; /* matches Y_AXIS_WIDTH */
}

.NOAPibAS1tx4M6kTmqOL {
  flex: 1;
  min-width: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: none; /* Firefox */
}

.NOAPibAS1tx4M6kTmqOL::-webkit-scrollbar {
  display: none; /* Chrome / Safari */
}

.Ph4CFGg2oIlqrAXCcee4 {
  position: relative;
  height: 40px; /* X_AXIS_HEIGHT */
  width: 100%;
}

/* ── Error state ────────────────────────────────────────── */

.F9ZFvPwVEL2pADm0BAJE {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #1f1f1f;
  font-size: 14px;
}

/* ── Legend ─────────────────────────────────────────────── */

.m4TdG19WiTpc6L4YsgIA {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin: 0;
  padding: 12px 20px;
  list-style: none;
  border-top: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/BudgetConsumptionReport/SpendBarChart/styles.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,uEAAuE;AACzE;;AAEA;EACE,QAAQ;EACR,sEAAsE;AACxE;;AAEA,gCAAsB,UAAU,EAAE;AAClC,+BAAsB,UAAU,EAAE;;AAElC,wBAAc,YAAY,EAAE;AAC5B,wBAAY,gBAAgB,EAAE;;AAE9B;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,yBAAyB;AACxC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,oBAAoB;AACrC;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,kBAAkB;EAChC,WAAW;AACb;;AAEA,8DAA8D;;AAE9D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[".box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* ── Chart data row ─────────────────────────────────────── */\n\n.scrollWrapper {\n  display: flex;\n  align-items: flex-start;\n  padding: 12px 12px 0;\n}\n\n.yAxisPanel {\n  flex-shrink: 0;\n  height: 280px;\n}\n\n.chartScrollWrapper {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.chartScrollWrapper::before,\n.chartScrollWrapper::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 24px;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n\n.chartScrollWrapper::before {\n  left: 0;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.07), transparent);\n}\n\n.chartScrollWrapper::after {\n  right: 0;\n  background: linear-gradient(to left, rgba(0, 0, 0, 0.07), transparent);\n}\n\n.shadowLeft::before { opacity: 1; }\n.shadowRight::after { opacity: 1; }\n\n.scrollable { cursor: grab; }\n.dragging { cursor: grabbing; }\n\n.chartScrollArea {\n  height: 280px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  user-select: none;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.45) transparent;\n}\n\n.chartScrollArea::-webkit-scrollbar {\n  height: 4px;\n}\n\n.chartScrollArea::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chartScrollArea::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.45);\n  border-radius: 2px;\n}\n\n.chartScrollArea::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.62);\n}\n\n.chartScrollInner {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n/* ── X-axis strip (separate row, scroll synced to main) ── */\n\n.xAxisRow {\n  display: flex;\n  padding: 0 12px;\n}\n\n.xAxisSpacer {\n  flex-shrink: 0;\n  width: 80px; /* matches Y_AXIS_WIDTH */\n}\n\n.xAxisScrollArea {\n  flex: 1;\n  min-width: 0;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  scrollbar-width: none; /* Firefox */\n}\n\n.xAxisScrollArea::-webkit-scrollbar {\n  display: none; /* Chrome / Safari */\n}\n\n.xAxisScrollInner {\n  position: relative;\n  height: 40px; /* X_AXIS_HEIGHT */\n  width: 100%;\n}\n\n/* ── Error state ────────────────────────────────────────── */\n\n.errorArea {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #1f1f1f;\n  font-size: 14px;\n}\n\n/* ── Legend ─────────────────────────────────────────────── */\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin: 0;\n  padding: 12px 20px;\n  list-style: none;\n  border-top: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `I9qitBUsK1qxrtishKcA`,
	"scrollWrapper": `BrIkaPNCgh3paJc1l9O9`,
	"yAxisPanel": `KEdDE7x4Iouw1TOGtFZR`,
	"chartScrollWrapper": `DmjM_grAlgF6YqICGopA`,
	"shadowLeft": `fZo9SSWK4XKkwgPmrTf_`,
	"shadowRight": `PaW7Iqc8IthirEjD3X80`,
	"scrollable": `nP0HEm9ZhhmAhB3beskA`,
	"dragging": `dskrNN8TL9fTjKeHYRnY`,
	"chartScrollArea": `d1EM8WLfuxvayimV_HZn`,
	"chartScrollInner": `KMss1DjKcj64o2eVAqiV`,
	"xAxisRow": `J09ihN6fRc3UTWzOvzTk`,
	"xAxisSpacer": `jZ8gDvCtWyBNeUhyk4B_`,
	"xAxisScrollArea": `NOAPibAS1tx4M6kTmqOL`,
	"xAxisScrollInner": `Ph4CFGg2oIlqrAXCcee4`,
	"errorArea": `F9ZFvPwVEL2pADm0BAJE`,
	"legend": `m4TdG19WiTpc6L4YsgIA`
};
export default ___CSS_LOADER_EXPORT___;
